import AgencyHelper from 'features/Agency/agencyHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import _ from 'lodash';
import PropTypes from 'prop-types';
import UIHelper from 'general/helpers/UIHelper';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';

VoucherBatchListFilterView.propTypes = {
    setFilterDropdown: PropTypes.func,
    filterDropdown: PropTypes.object,
    onCancel: PropTypes.func,
    onApply: PropTypes.func,
};

function VoucherBatchListFilterView({
    setFilterDropdown,
    filterDropdown,
    onCancel,
    onApply,
    closeDropdown,
}) {
    // MARK: ---- PROPERTIES ----

    // MARK: ---- METHODS ----
    const handleApplyFilter = () => {
        AgencyHelper.Filter.voucherBatchList = {
            ...AgencyHelper.Filter.voucherBatchList,
            q: filterDropdown.q,
            page: 0,
            batchType: filterDropdown.batchType,
            identityType: filterDropdown.identityType,
            status: filterDropdown.status,
            from: filterDropdown.from,
            to: filterDropdown.to,
            dateFilter: filterDropdown.dateFilter,
        };
        if (onApply) onApply();
        if (closeDropdown) closeDropdown();
    };
    const handleClearFilter = () => {
        AgencyHelper.Filter.voucherBatchList = {
            q: '',
            page: 0,
            limit: AppConfigs.defaultPageLimit,
            batchType: '',
            identityType: '',
            status: '',
            dateFilter: dateFilter.tatCaThoiGian,
            from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
            to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
        };
        setFilterDropdown(AgencyHelper.Filter.voucherBatchList);
        if (onCancel) onCancel();
        if (closeDropdown) closeDropdown();
    };
    return (
        <div className='pb-4'>
            <div className='row p-4'>
                <div className="col-12 px-4">
                    <KTFormSearch
                        name="search-bar"
                        placeholder="Theo mã lô voucher, tên đối tác"
                        value={filterDropdown.q}
                        onSubmit={(text) => {
                            const updateFilterDropdown = { ...filterDropdown, q: text };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
                <div className="col-6 pr-2 pt-2">
                    <KTDropdownFilter
                        label="Hình thức phát hành"
                        filterKey="type"
                        options={[
                            { name: "Tất cả", value: "" },
                            ...AgencyHelper.Data.voucherBatchTypeOptions,
                        ]}
                        selectedValue={filterDropdown.type}
                        handleChange={(value) => {
                            const updateFilterDropdown = { ...filterDropdown, type: value };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
                <div className="col-6 pl-2 pt-2">
                    <KTDropdownFilter
                        label="Đối tượng nhận voucher"
                        filterKey="identityType"
                        options={[
                            { name: "Tất cả", value: "" },
                            ...AgencyHelper.Data.voucherIdentityTypeOptions,
                        ]}
                        selectedValue={filterDropdown.identityType}
                        handleChange={(value) => {
                            const updateFilterDropdown = { ...filterDropdown, identityType: value };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
                <div className="col-6 pr-2">
                    <KTDropdownFilter
                        label="Trạng thái lô voucher"
                        filterKey="status"
                        options={[
                            { name: "Tất cả", value: "" },
                            ...AgencyHelper.Data.voucherBatchStatusOptions,
                        ]}
                        selectedValue={filterDropdown.status}
                        handleChange={(value) => {
                            const updateFilterDropdown = { ...filterDropdown, status: value };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>

                <div className="col-6 pl-2 pt-2">
                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                        Ngày tạo
                    </label>
                    <CustomDateRangePicker
                        toggleElementBorderRadius={5}
                        alignRight={true}
                        initialValue={
                            filterDropdown.dateFilter?.length > 0
                                ? filterDropdown.dateFilter
                                : dateFilter.tatCaThoiGian
                        }
                        onPressSave={(selectedValue, startDate, endDate) => {
                            const updateFilterDropdown = {
                                ...filterDropdown,
                                from: startDate,
                                to: endDate,
                                dateFilter: selectedValue,
                            };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>
            </div>
            {/* actions */}
            <div
                className="px-4 pt-2 pb-0 d-flex align-items-center justify-content-end gap-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Đặt lại mặc định', handleClearFilter)}
                {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
            </div>
        </div>
    );
}

export default VoucherBatchListFilterView;
